import Icon from './src/icon';

export default Icon;



// WEBPACK FOOTER //
// ./packages/icon/index.js